/**
 * Custom error class for handling token not found errors.
 * This error is thrown when a required token (access or refresh) is not found in session storage.
 */
export class TokenNotFoundError extends Error {}
